import React, { useContext, useEffect, useState } from "react";
import PlantillaScreen from "../../helpers/PlantillaScreen";
import TimeLineTarget from "../TimeLine/TimeLineTarget";
import ComputerIcon from "@mui/icons-material/Computer";
import ChecklistIcon from "@mui/icons-material/Checklist";
import ManageSearchIcon from "@mui/icons-material/ManageSearch";
import FactCheckIcon from "@mui/icons-material/FactCheck";
import PriceCheckIcon from "@mui/icons-material/PriceCheck";
import RequestPageIcon from "@mui/icons-material/RequestPage";
import { ModalSolicitudCredito } from "../Modales/ModalSolicitudCredito";
import { LoaderScreen } from "../../components/LoaderScreen";
import { AnalisisCreditoContext } from "../AnalisisCreditoScreen";
import MdlSolicitudCreditoScreen from "../Modales/MdlSolicitudCreditoScreen";
import MdlValidacionPedido from "../Modales/MdlValidacionPedido";
import MdlAnalisisSolicitud from "../Modales/MdlAnalisisSolicitud";
import MdlDictamen from "../Modales/MdlDictamen";
import MdlEnganche from "../Modales/MdlEnganche";
import MdlFacturacion from "../Modales/MdlFacturacion";
import { AnalisisComentariosLine } from "../AnalisisComentariosLine";
import Swal from "sweetalert2";
import request from "../../../Helpers/API";
export const OperacionExpress = ({ data, estado, upload, direccion }) => {
  const { state } = useContext(AnalisisCreditoContext);
  const [openSolicitud, setOpenSolicitud] = useState(false);
  const [value, setValue] = useState(0);
  const [comentarios, setComentario] = useState([]);
  const [loader, setLoader] = useState({
    mostrar: false,
    alerta: false,
    error: false,
    mensaje: "",
  });
  useEffect(() => {
    onActualizarComentarios();
  }, []);
  const onActualizarComentarios = () => {
    if (
      state.folio === undefined ||
      state.folio === null ||
      state.folio.length !== 13
    ) {
      return;
    }
    setLoader({ ...loader, mostrar: true });
    request
      .get(`AnalisisSolicitudCreditoComentarios/Listado?folio=${state.folio}`)
      .then((result) => {
        setLoader({ ...loader, mostrar: false });
        setComentario(result);
      })
      .catch((error) => {
        setLoader({ ...loader, mostrar: false });
        Swal.fire("ANALISIS DE SOLICITU", JSON.stringify(error), "error");
      });
  };
  return (
    <PlantillaScreen
      titulo={"AUTORIZACION DE CREDITO DE LINEA DE OPERACION EXPRESS"}
      className={"analisis-sc-procesos"}
    >
      <LoaderScreen loader={loader} />
      <ModalSolicitudCredito
        open={openSolicitud}
        setOpenSolicitud={setOpenSolicitud}
        value={value}
        setValue={setValue}
        maxValue={Number(estado.pantallacompleta)}
        upload={upload}
        screens={{
          screen0: (
            <MdlSolicitudCreditoScreen
              folio={state.folio}
              setLoader={setLoader}
              loader={loader}
            />
          ),
          screen1: (
            <MdlValidacionPedido
              folio={state.folio}
              setLoader={setLoader}
              loader={loader}
              updateComentarios={onActualizarComentarios}
            />
          ),
          screen2: (
            <MdlAnalisisSolicitud
              folio={state.folio}
              setLoader={setLoader}
              loader={loader}
            />
          ),
          screen3: (
            <MdlDictamen
              folio={state.folio}
              setLoader={setLoader}
              loader={loader}
              updateComentarios={onActualizarComentarios}
            />
          ),
          screen4: (
            <MdlEnganche
              folio={state.folio}
              setLoader={setLoader}
              loader={loader}
              updateComentarios={onActualizarComentarios}
            />
          ),
          screen5: (
            <MdlFacturacion
              folio={state.folio}
              setLoader={setLoader}
              loader={loader}
              updateComentarios={onActualizarComentarios}
            />
          ),
        }}
        titulos={{
          screen0: "SOLICITUD DE CREDITO",
          screen1: "VALIDAR PEDIDO",
          screen2: "ANALIZAR SOLICITUD DE CREDITO",
          screen3: "DICTAMEN",
          screen4: "VALIDAR ENGANCHE",
          screen5: "FACTURAR EQUIPO",
        }}
      />
      <div className="analisis-sc-procesos-timeline scroll-4">
        <TimeLineTarget
          icon={<ComputerIcon />}
          title={"Genero Solicitud"}
          subtitle={"Vendedor"}
          footer={{
            tiempoestimado: data[0].estado,
            leyenda: data[0].creado,
            duracion: data[0].tiempoestimado,
            comentarios: "",
          }}
          openModal={setOpenSolicitud}
          color={data[0].control}
          active={1 === Number(estado.pantallacompleta)}
          value={0}
          setValue={setValue}
        />
        <TimeLineTarget
          icon={<ChecklistIcon />}
          title={"Validar Pedido"}
          subtitle={"Gerente de sucursal"}
          footer={{
            tiempoestimado: data[1].estado,
            leyenda: data[1].creado,
            duracion: data[1].tiempoestimado,
            comentarios: "",
          }}
          openModal={setOpenSolicitud}
          color={data[1].control}
          active={2 === Number(estado.pantallacompleta)}
          value={1}
          setValue={setValue}
        />
        <TimeLineTarget
          icon={<ManageSearchIcon />}
          title={"Analizar Solicitud"}
          subtitle={"Coordinadora de credito"}
          footer={{
            tiempoestimado: data[2].estado,
            leyenda: data[2].creado,
            duracion: data[2].tiempoestimado,
            comentarios: "",
          }}
          openModal={setOpenSolicitud}
          color={data[2].control}
          active={3 === Number(estado.pantallacompleta)}
          value={2}
          setValue={setValue}
        />
        <TimeLineTarget
          icon={<FactCheckIcon />}
          title={"Dictamen"}
          subtitle={"Coordinadora de credito"}
          footer={{
            tiempoestimado: data[3].estado,
            leyenda: data[3].creado,
            duracion: data[3].tiempoestimado,
            comentarios: "",
          }}
          openModal={setOpenSolicitud}
          color={data[3].control}
          active={4 === Number(estado.pantallacompleta)}
          value={3}
          setValue={setValue}
        />
        <TimeLineTarget
          icon={<PriceCheckIcon />}
          title={"Validar Enganche"}
          subtitle={"Ventas"}
          footer={{
            tiempoestimado: data[4].estado,
            leyenda: data[4].creado,
            duracion: data[4].tiempoestimado,
            comentarios: "",
          }}
          openModal={setOpenSolicitud}
          color={data[4].control}
          active={5 === Number(estado.pantallacompleta)}
          value={4}
          setValue={setValue}
        />
        <TimeLineTarget
          icon={<RequestPageIcon />}
          title={"Facturar Equipo"}
          subtitle={"Ventas"}
          footer={{
            tiempoestimado: data[5].estado,
            leyenda: data[5].creado,
            duracion: data[5].tiempoestimado,
            comentarios: "",
          }}
          openModal={setOpenSolicitud}
          color={data[5].control}
          active={6 === Number(estado.pantallacompleta)}
          value={5}
          setValue={setValue}
          endtarget={true}
        />
      </div>

      <AnalisisComentariosLine
        tiempotranscurrido={estado.tiempotranscurrido}
        tiempoestimado={estado.tiempoestimado}
        comentarios={comentarios}
      />
    </PlantillaScreen>
  );
};
